<template>
  <div style="width: 100%;height: 100%;">
    <div v-if="repairPlan !== undefined">
      <div v-for="(item,index) in troublePlanList" class="trouble-item" :key="item.id">
        <div class="title">
          <span>{{ '定损故障' + (index + 1) }}</span>
        </div>
        <FrameForm :readonly="true" :ref="'item_'+index" component-param="bu_item_repair_plan"
                   :init-data="item"></FrameForm>
      </div>
    </div>
    <div class="remark-text" v-else>暂无维修方案</div>
    <div v-if="showSupplementMaterial">
      <div v-for="item in supplementMaterialList" class="trouble-item" :key="item.id">
        <div class="title">
          <span>{{ '补料编号：' + item.id }}</span>
        </div>
        <FrameForm component-param="bu_supplement_material" :init-data="item.supplementMaterialData" />
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "BuItemRepairDetail",
  inject: ['$fn'],
  props: {
    parentData: {
      type: Object,
      default: () => {
        return {}
      }
    }
  },
  data() {
    return {
      repairPlan: {},
      troublePlanList: [],
      supplementMaterialList:[],
      showSupplementMaterial:false
    }
  },
  async created() {
    await this.getItemRepairPlan()
    await this.getSupplementMaterial()
  },
  methods: {
    async getItemRepairPlan(){
      let data = await this.$http("buItemService.getItemRepairPlan",this.parentData);
      this.repairPlan = data
      if (this.repairPlan !== undefined){
        this.troublePlanList = this.repairPlan.form_data.trouble_plan_list
      }
    },
    //获取补料数据
    async getSupplementMaterial() {
      let data = await this.$http('buItemStationService.getSupplementMaterial', {item_id: this.parentData.id,});
      if(data){
        this.initData = data.supplementMaterialList;
        this.showSupplementMaterial = data.showSupplementMaterial;
      }

    },
  }
}
</script>

<style scoped lang="less">
.remark-text{
  line-height: 100px;
  text-align: center;
  font-weight: bold;
  font-size: 20px;
  color: #a0a0a0;
}
.trouble-item {
  border: 1px solid #ddd;
  margin-bottom: 10px;
  margin-left: 10px;
  margin-right: 10px;

  .title {
    background-color: #ddd;
    padding: 5px 0 5px 10px;
    font-weight: bold;
  }
}
</style>